<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <v-row>
        <v-col class="py-0">
          <p class="mt-n1" style="font-size: 16px">{{ description }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <publico-alvo segment-view-type="edit" :segmentos.sync="segmentsLocal" :error="error" :disable="disabled" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <mf-info-card icon="info" :vHtml="infoContent" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  components: {
    PublicoAlvo: () => import('@/modules/campanhas/views/components/PublicoAlvo.vue'),
  },
  props: {
    segments: Array,
    error: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    infoContent: {
      type: String,
      required: true,
    },
  },
  computed: {
    segmentsLocal: {
      get() {
        return this.segments
      },
      set(value) {
        this.$emit('update:segments', value)
      },
    },
  },
}
</script>
